import { lazy } from "react";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { FaRegUserCircle, FaRobot } from "react-icons/fa";
import { LuBell } from "react-icons/lu";
import { RxDashboard } from "react-icons/rx";
import {
  TbAdjustmentsHorizontal,
  TbCategoryPlus,
  TbMapPin,
  TbUser,
  TbUsersGroup,
} from "react-icons/tb";

const Login = lazy(() => import("../pages/Login"));
const ProfileSettings = lazy(() => import("../pages/AccountSetting"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Notifications = lazy(() => import("../pages/Notifications"));
const SubscriptionManagement = lazy(
  () => import("../pages/SubscriptionManagement"),
);
const UserManagement = lazy(() => import("../pages/UserManagement"));
const AddEditBlog = lazy(() => import("../pages/Crud/Blogs/AddEditBlog"));
const UserManagmentDetails = lazy(
  () => import("../pages/UserManagement/UserManagmentDetails"),
);
const UserAnalytics = lazy(() => import("../pages/UserAnalytics"));
const Cms = lazy(() => import("../pages/Cms"));
const Chat = lazy(() => import("../pages/Chat"));
const Crud = lazy(() => import("../pages/Crud"));
const ChatBot = lazy(() => import("../pages/ChatBot"));
const Itineraries = lazy(() => import("../pages/Itineraries"));
const ItineraryDetail = lazy(
  () => import("../pages/Itineraries/ItineraryDetail"),
);

export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    element: <Login />,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <RxDashboard />,
    element: <Dashboard />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    icon: <TbUser />,
    element: <UserManagement />,
  },
  {
    path: "/user-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <UserManagmentDetails />,
  },
  {
    path: "/subscription-management",
    title: "Subscription",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <AiOutlineDollarCircle />,
    element: <SubscriptionManagement />,
  },
  {
    path: "/user-analytics",
    title: "AI & User Analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <TbUsersGroup />,
    element: <UserAnalytics />,
  },
  {
    path: "/chat-bot",
    title: "Chat Bot",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <FaRobot />,
    element: <ChatBot />,
  },
  {
    path: "/itineraries",
    title: "Itineraries",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <TbMapPin />,
    element: <Itineraries />,
  },
  {
    path: "/itineraries/:id",
    title: "Itinerary Detail",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <ItineraryDetail />,
  },
  {
    path: "/cms",
    title: "CMS",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <TbAdjustmentsHorizontal />,
    element: <Cms />,
  },
  {
    path: "/chat",
    title: "Chat",
    exact: true,
    protected: true,
    // showInSidebar: true,
    // icon: <TbUsersGroup />,
    element: <Chat />,
  },
  {
    path: "/crud",
    title: "CRUD",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <TbCategoryPlus />,
    element: <Crud />,
  },
  {
    path: "/settings",
    title: "Profile Settings",
    exact: true,
    protected: true,
    showInSidebar: false,
    icon: <FaRegUserCircle />,
    element: <ProfileSettings />,
  },
  {
    path: "/notifications",
    title: "Notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    icon: <LuBell />,
    element: <Notifications />,
  },
  {
    path: "/blogs/add-edit",
    exact: true,
    protected: true,
    element: <AddEditBlog />,
  },
];
